/**
 * Formats a number to a given decimal precision and splitting thousands
 * @param num the number to be formatted
 * @param trailLength the length of trailing digits
 * @param decimalSeparator the separator for decimals (defults to ".")
 * @param thousandSeparator the separator for thousands (defaults to ",")
 * @returns the formatted string
 */
function formatDecimal(num, trailLength = 2, decimalSeparator = '.', thousandSeparator = ',') {
    const s = num.toFixed(trailLength);
    const split = s.split('.');
    let s0 = split[0];
    let s1 = split[1];
    s0 = s0.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    if (s1.length < trailLength) {
        s1 = split[1].padEnd(2, '0');
    }
    return `${s0}${decimalSeparator}${s1}`;
}

export { formatDecimal };
//# sourceMappingURL=formatDecimal.js.map
